// extracted by mini-css-extract-plugin
module.exports = {"message":"profile_message__1VhH4","userInfo":"profile_userInfo__2hXgE","title":"profile_title__1F3Fm","topic":"profile_topic__2Nm17"};